// extracted by mini-css-extract-plugin
export var returnLink = "project-module--returnLink--1XDHZ";
export var content = "project-module--content--1Y1wT";
export var articleMetadata = "project-module--articleMetadata--3ssSE";
export var tagsWrapper = "project-module--tagsWrapper--30aaO";
export var tag = "project-module--tag--3eIOh";
export var featured = "project-module--featured--d4bwb";
export var body = "project-module--body--1Ww__";